import React from 'react';
import './App.scss';
import { Routes, Route } from 'react-router-dom';

import Header from './layout/header';
import Footer from './layout/footer';
import AboutPage from './pages/about-us';
import HomePage from './pages/home';
import Services from './pages/services';
import ContactUs from './pages/contact-us';

function App() {
  return (
    <div>
      <Header />
      <Routes>
        <Route path="/" element={<HomePage/>}/>
        <Route path="/about-us" element={<AboutPage />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact-us" element={<ContactUs />} />
        
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
